import { useContext } from 'react';
import { DictionariesContext } from '@/creditflowresearch/application/Dictionaries/DictionariesContext';
import { useHeaderMenuContext } from './HeaderMenuContext';

const useHeaderMenuData = () => {
  const v2 = useHeaderMenuContext();
  const legacy = useContext(DictionariesContext);

  return v2.isHeaderInitialized ? v2 : (legacy ?? v2);
};

export default useHeaderMenuData;
